import React from 'react';
import PropTypes from 'prop-types';
import { openMiniature, closeMiniature } from '../features/miniature';
import IconArrow from './icon-arrow';
import { POSITION_RIGHT, POSITION_LEFT } from '../constants';
export default function MiniatureToggleButton(_ref) {
  let {
    value,
    onChangeValue,
    position
  } = _ref;
  let style = {
    width: "24px",
    height: "24px",
    display: "block",
    position: "absolute",
    bottom: 0,
    [position === POSITION_LEFT ? 'left' : 'right']: '0px',
    background: "rgba(19, 20, 22, 0.901961)",
    border: 0,
    padding: 0,
    outline: 0,
    color: "#fff"
  };
  let action = value.miniatureOpen ? closeMiniature : openMiniature;
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    style: style,
    onClick: () => onChangeValue(action(value))
  }, /*#__PURE__*/React.createElement(IconArrow, {
    open: value.miniatureOpen,
    position: position
  }));
}
MiniatureToggleButton.propTypes = {
  value: PropTypes.object.isRequired,
  onChangeValue: PropTypes.func.isRequired,
  position: PropTypes.oneOf([POSITION_RIGHT, POSITION_LEFT]).isRequired
};